<template>
    <AppLayout title="Editar sucursal">
        <Breadcrumb
            name="Sucursales"
            routeName="sucursales"
            page="Editar parametros de credencial"
        />

        <form class="p-2">
            <div class="flex flex-col w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Configuración de Parametros para {{ proveedor.nombre }}
                    </div>
                    <div v-if="parametros.length">
                        <div
                            v-for="parametro in parametros"
                            :key="parametro.id"
                        >
                            <div class="flex flex-col h-24">
                                <label
                                    :for="parametro.key"
                                    class="my-1 text-gray-700"
                                >
                                    {{ parametro.key }}
                                </label>
                                <input
                                    type="text"
                                    :id="parametro.key"
                                    class="t-input"
                                    v-model="form.json[parametro.key]"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-gray-800 mt-2">
                        El proveedor no posee parametros para credenciales.
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end lg:max-w-3xl">
                    <Button variant="dismissive" @click="goBack()" > Volver </Button>
                <Button @click.prevent="update"> Editar credenciales </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        credencial: Object,
        parametros: Array,
        //array_parametros: Array,
        proveedor: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                json: JSON.parse(this.credencial.json),
            }),
        };
    },
    methods: {
        update() {
            this.form.json = JSON.stringify(this.form.json);
            this.form.put("/credenciales/" + this.credencial.id);
        },
        goBack() {
            this.$inertia.visit(this.$page.props.urlPrev);
        }
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
